import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('ShopPackReward')
export class ShopPackReward {

  @JsonProperty('shop_item_id', Number)
  shopItemId: number = 0;

  @JsonProperty('currency_type', Number)
  currencyType: number = 0;

  @JsonProperty('currency_quantity', Number)
  currencyQuantity: number = 0;

  @JsonProperty('currency_ticket_cost', Number)
  currencyTicketCost: number = 0;

  @JsonProperty('currency_increase_percent', Number)
  currencyIncreasePercent: number = 0;
}
